import React from "react";
import { FcFolder } from "react-icons/fc";
import { AiOutlinePlusSquare } from "react-icons/ai";

const CategoryList = (props) => {
  const {
    categories,
    isAdding,
    onCategory,
    onAddCategory,
    selectedCategory,
    isViewDetail,
  } = props;

  const isEdit = Object.keys(selectedCategory).length > 0;
  return (
    <div className="relative">
      {(isEdit && !isViewDetail) || isAdding ? (
        <div
          // onClick={onBackToCategory}
          className="absolute w-[13.5rem] h-[23.5rem] bg-[#222222] opacity-30"
        ></div>
      ) : null}
      <div className="border border-primary-grey w-[13.5rem] h-[23.5rem] overflow-auto">
        <ul className="p-4 text-[13px]">
          <div className="cursor-pointer flex gap-21 items-center my-1">
            <FcFolder className="text-lg" />
            <span className="ml-1.5">전체</span>
          </div>
          {categories?.map((val) => {
            return (
              <li
                className="cursor-pointer flex items-center my-[7px]"
                key={val?.id}
                onClick={() => onCategory(val)}
              >
                <AiOutlinePlusSquare />
                <FcFolder className="text-lg ml-0.5" />
                <span className="text-[12px] ml-1.5">{val?.name}</span>
              </li>
            );
          })}
        </ul>
      </div>
      {!isAdding ? (
        <button
          onClick={onAddCategory}
          className={`bg-gradient-to-b from-white via-primary-white to-background-grey border border-button-grey w-full text-[12px] py-2 rounded-[4px] mt-3`}
        >
          카테고리 추가
        </button>
      ) : null}
    </div>
  );
};

export default CategoryList;
